import { Alert } from '@cmsgov/ds-medicare-gov'
import { useReturnTrueForXSeconds } from 'hooks/useDisplayForXSeconds'
import { useTranslation } from 'react-i18next'

export const MfaOptionRemovedAlert = () => {
  const { t } = useTranslation('accountSettings')

  const displayAlert = useReturnTrueForXSeconds({
    seconds: 7,
    initialValue: true
  }, [])

  return (
    <>
      {displayAlert && (
        <Alert variation='success' className='my-u-mb--10'>
          {t('mfaOptionRemoved')}
        </Alert>
      )}
    </>
  )
}
